import { EquipmentIcon } from "@xola/icons";
import clsx from "clsx";
import React from "react";
import { Permission, Timeslot } from "types";
import { useExperience } from "../../../hooks/resources/useProduct";
import { IsGranted } from "../../Common/IsGranted";
import { DashboardInventoryResource } from "./DashboardInventoryResource";
import { DisplayType } from "./ResourceDisplay";

interface InventoryDisplayProps {
    timeslot: Timeslot;
    displayType?: DisplayType;
    className?: string;
}

export const InventoryDisplay = ({ timeslot, displayType, className }: InventoryDisplayProps) => {
    const { data: experience } = useExperience(timeslot.product);
    const hasNoInventory = experience?.resources?.length === 0;
    const isCompact = displayType === DisplayType.COMPACT;

    if (hasNoInventory) {
        return <span className={clsx("transparent", isCompact ? "inline-block" : "w-24 truncate xl:w-28 2xl:w-32")} />;
    }

    return (
        <IsGranted permissions={Permission.DASHBOARD_VIEW}>
            <DashboardInventoryResource
                icon={<EquipmentIcon />}
                className={clsx("ui-dashboard-inventory", className)}
                timeslot={timeslot}
                displayType={displayType}
            />
        </IsGranted>
    );
};
